import api from "@/api.js";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    siteData: {},
    fullLoading: true,
    dateRange: [],
    debugDateRange: [],
    navigationDrawer: true,
    siteSettings: {
      triggerEventsPerPage: 25,
      deviceStatusesPerPage: 25
    },
    offlineMode: false,
    appID: {},
    apiUrl: "",
    miniNavState: false,
    // Session-only state (not persisted)
    showOverlaysByDefault: true
  },
  mutations: {
    setSiteData(state, payload) {
      state.siteData = payload;
    },
    setFullLoader(state, loading) {
      state.fullLoading = loading;
    },
    setDebugDateRange(state, date) {
      state.debugDateRange = date;
    },
    setDateRange(state, date) {
      state.dateRange = date;
    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    },
    setOfflineMode(state, mode) {
      state.offlineMode = mode;
    },
    setSelectedRowData(state, rowData) {
      state.selectedRowData = rowData;
    },
    setAppID(state, id) {
      state.appID = id;
    },
    setApiUrl(state, apiUrl) {
      state.apiUrl = apiUrl;
    },
    setMiniNavState(state, payload) {
      state.miniNavState = payload;
    },
    setSiteSettings(state, payload) {
      state.siteSettings = payload;
    },
    setShowOverlaysByDefault(state, value) {
      state.showOverlaysByDefault = value;
    }
  },
  actions: {
    async loadSiteData({ commit }) {
      let siteData = await api.get("applications/siteData");
      commit("setSiteData", siteData.data);
      document.title = siteData.data.name;
      let baseUrl = "https://api.flexi-comms.com";
      let host = window.location.host;
      if (
        host == "localhost:8080" ||
        host == "localhost:8081" ||
        host == "localhost:8082" ||
        host == "192.168.178.21:8080" ||
        host == "192.168.178.21:8081" ||
        host == "192.168.178.21:8082" ||
        host == "10.0.0.9:8080"
      ) {
        baseUrl = "http://localhost:32775";
      } else if (host == "flexicomms.firebaseapp.com") {
        baseUrl = "https://flexi-comms-api.simplesoftware.nz";
      } else if (host.substring(0, 4) == "dev.") {
        baseUrl = "https://flexi-comms-api.simplesoftware.nz";
      }
      commit("setApiUrl", baseUrl);
    },
    checkOnlineStatus({ commit }) {
      commit("setOfflineMode", !navigator.onLine);
    },
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },

    async loadDateRange({ commit, dispatch }, payload) {
      commit("setDateRange", payload);
      if (!payload.raw) {
        dispatch("events/loadTriggers", null, { root: true });
        dispatch("events/loadAll", null, { root: true });
      } else {
        dispatch("events/loadAllRaw", null, { root: true });
      }
    },
    async loadDebugDateRange({ commit, dispatch }, payload) {
      commit("setDebugDateRange", payload);

      dispatch("events/loadAllRaw", null, { root: true });
    },
    async loadDefaultDateRange({ commit }) {
      commit("setDateRange", {
        to: `${moment().format("YYYY/MM/DD")}`,
        from: `${moment()
          .day(-7)
          .format("YYYY/MM/DD")}`
      });
    },
    async getAppID({ commit }) {
      if (
        window.location.host == "flexicomms.firebaseapp.com" ||
        window.location.host == "localhost:8080" ||
        window.location.host == "192.168.178.21:8080"
      ) {
        commit("setAppID", 0);
      }
    },
    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    },
    togglMiniNav({ commit, state }) {
      commit("setMiniNavState", !state.miniNavState);
    },
    changeTriggerEventsPerPage({ state, commit }, payload) {
      let settings = state.siteSettings;
      settings.triggerEventsPerPage = payload;
      commit("setSiteSettings", settings);
    },
    changeDeviceStatusesPerPage({ state, commit }, payload) {
      let settings = state.siteSettings;
      settings.deviceStatusesPerPage = payload;
      commit("setSiteSettings", settings);
    },
    toggleShowOverlaysByDefault({ commit, state }) {
      commit("setShowOverlaysByDefault", !state.showOverlaysByDefault);
    }
  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    dateRange(state) {
      return state.dateRange;
    },
    debugDateRange(state) {
      return state.debugDateRange;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    },
    offlineMode(state) {
      return state.offlineMode;
    },
    apiUrl(state) {
      return state.apiUrl;
    },
    miniNavState(state) {
      return state.miniNavState;
    },
    siteSettings(state) {
      return state.siteSettings;
    },
    showOverlaysByDefault(state) {
      return state.showOverlaysByDefault;
    }
  }
};
